var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29289 1.5L3.64645 6.14645C3.45118 6.34171 3.45118 6.65829 3.64645 6.85355C3.84171 7.04882 4.15829 7.04882 4.35355 6.85355L9 2.20711V4C9 4.27614 9.22386 4.5 9.5 4.5C9.77614 4.5 10 4.27614 10 4V1.00049C10 1.00033 10 1.00016 10 1C10 0.992002 9.99981 0.984005 9.99943 0.976015C9.9967 0.918935 9.98425 0.862233 9.96206 0.808609C9.93766 0.749636 9.90149 0.694385 9.85355 0.646447C9.80562 0.598508 9.75036 0.562339 9.69139 0.537939C9.63244 0.513493 9.56779 0.5 9.5 0.5H6.5C6.22386 0.5 6 0.723858 6 1C6 1.27614 6.22386 1.5 6.5 1.5H8.29289ZM1.5 3C1.36739 3 1.24021 3.05268 1.14645 3.14645C1.05268 3.24021 1 3.36739 1 3.5V9C1 9.13261 1.05268 9.25978 1.14645 9.35355C1.24021 9.44732 1.36739 9.5 1.5 9.5H7C7.13261 9.5 7.25978 9.44732 7.35355 9.35355C7.44732 9.25978 7.5 9.13261 7.5 9V6C7.5 5.72386 7.72386 5.5 8 5.5C8.27614 5.5 8.5 5.72386 8.5 6V9C8.5 9.39783 8.34196 9.77936 8.06066 10.0607C7.77936 10.342 7.39783 10.5 7 10.5H1.5C1.10217 10.5 0.720644 10.342 0.43934 10.0607C0.158035 9.77936 0 9.39783 0 9V3.5C0 3.10218 0.158035 2.72064 0.43934 2.43934C0.720644 2.15804 1.10218 2 1.5 2H4.5C4.77614 2 5 2.22386 5 2.5C5 2.77614 4.77614 3 4.5 3H1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.94817f689fc0203bcabb37cf7dc103c8.svg";
export { ForwardRef as ReactComponent };